import React from 'react'
import { CategoryToolTipProps } from './CategoryToolTip.types'
import styles from './CategoryToolTip.module.scss'
import cl from 'classnames'
import { ToolTipContent } from '../ToolTipContent'

const CategoryToolTipComponent = (props: CategoryToolTipProps) => {
  const {
    className,
    style,
    toolTipContentProps
  } = props

  const renderContentOnLeft: boolean = window.innerWidth / 2 < (typeof style?.left === 'number' ? style.left : 0);

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >

      <div className={styles.verticalLine} />

      <div
        className={styles.tooltipContainer}
        style={{
          marginLeft: renderContentOnLeft ? '-100%' : undefined
        }}
      >
        <ToolTipContent
          {...toolTipContentProps}
        />
      </div>

    </div>
  )
}

const CategoryToolTip = CategoryToolTipComponent
export { CategoryToolTip }
